export { default as getVoucherkuMock } from './get_voucherku';
export { default as bulkValidateVoucherMock } from './bulk_validate_voucher';

function delay(value, time = 1000) {
  return new Promise(resolve => {
    setTimeout(resolve.bind(undefined, value), time);
  })
}

export default {
  getVoucherku: () => delay({}),
  bulkValidateVoucher: () => delay({}),
}
